import { HawkSearchGlobal, RawRecommendationsRequest, RawRecommendationsResponse, RecommendationsRequest, RecommendationsResponse } from '@models';
import { BaseService } from './base.service';

declare let HawkSearch: HawkSearchGlobal;

export class RecommendationsService extends BaseService {
    protected baseUrl = HawkSearch.config.endpoints?.recommendations || 'https://recs-dev.hawksearch.net/api/recommendation/v2';

    // #region Search Operations

    getItems(recommendationsRequest: RecommendationsRequest): Promise<RecommendationsResponse> {
        return this.executeRecommendations(recommendationsRequest);
    }

    private executeRecommendations(recommendationsRequest: RecommendationsRequest): Promise<RecommendationsResponse> {
        const rawRecommendationsRequest: RawRecommendationsRequest = {
            clientGuid: HawkSearch.config.clientId,
            landingPageUrl: recommendationsRequest.url,
            renderHTML: false,
            visitId: this.getVisitId(),
            visitorId: this.getVisitorId(),
            widgetUids: [
                {
                    widgetGuid: recommendationsRequest.widgetId,
                    uniqueid: recommendationsRequest.itemId
                }
            ]
        };

        this.triggerEvent('hawksearch:before-recommendations-executed', rawRecommendationsRequest);

        return this.httpPost<RawRecommendationsResponse>('/getwidgetitems', rawRecommendationsRequest).then((rawRecommendationsResponse) => {
            this.triggerEvent('hawksearch:after-recommendations-executed', rawRecommendationsResponse);

            const recommendationsResponse = this.convertResponse(rawRecommendationsResponse);

            this.triggerEvent('hawksearch:recommendations-completed', recommendationsResponse);

            this.bindComponents(recommendationsResponse);

            return recommendationsResponse;
        });
    }

    private convertResponse(rawRecommendationsResponse: RawRecommendationsResponse): RecommendationsResponse {
        return {
            requestId: rawRecommendationsResponse.requestId,
            widgets: rawRecommendationsResponse?.widgetItems?.map((w) => ({
                id: w.widgetGuid,
                requestId: rawRecommendationsResponse.requestId,
                title: w.widgetName,
                carousel: w.isCarousel,
                items: w.recommendationItems?.map((i) => ({
                    attributes: i.customDict,
                    brand: i.brand || undefined,
                    color: i.color || undefined,
                    description: i.shortDescription || undefined,
                    id: i.id,
                    imageUrl: i.imageUrl,
                    price: this.getFloat(i.price),
                    rating: this.getFloat(i.rating),
                    salePrice: this.getFloat(i.salePrice),
                    sku: i.sku || undefined,
                    title: i.itemName,
                    url: i.url
                }))
            }))
        };
    }

    private getFloat(value: string | undefined): number | undefined {
        if (typeof value !== 'string') {
            return undefined;
        }

        return parseFloat(value);
    }

    // #endregion Search Operations

    // #region Events

    bindComponents(recommendationsResponse: RecommendationsResponse): void {
        recommendationsResponse.widgets?.forEach((w) => {
            this.triggerBindEvent('recommendations', w, w.id);
        });
    }

    // #endregion Events
}

export const recommendationsService = new RecommendationsService();
